import type {
  TReducerAction,
  TTransition,
  TTransitions,
} from './reducer.types.ts';

export const createReducer =
  <TState, TAction extends TReducerAction>(
    transitions: TTransitions<TState, TAction>,
  ) =>
  <TType extends TAction['type']>(
    state: TState,
    action: Extract<TAction, { type: TType }>,
  ): TState => {
    if (!Object.hasOwn(transitions, action.type)) {
      return state;
    }

    const transition: TTransition<TState, TAction, TType> =
      transitions[action.type];

    return transition(state, action);
  };
